export const formikHelper = {
  checkHasError: (meta) => typeof meta.error === 'string' && meta.error.length > 0,

  checkIsInvalid: (meta) => meta.touched && formikHelper.checkHasError(meta),
}
